import { AboutPage } from '@/lib/pages/about';

import { IMainPage, ISocialsData, getIndexData } from '@/lib/entities/page';
import { fetchPageSeo, PageSeo } from '@/lib/entities/seo';
import { SeoEntries } from '@/lib/entities/seo/lib/seo-entries';
import { getSocialData } from '@/lib/entities/social';

import { GetStaticProps } from 'next';
import { i18n, useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import { isDevelopment } from '../lib/config';

interface IProps {
  data: IMainPage;
  shareContent: ISocialsData;
  pageSeo: PageSeo | null;
}
export default function About({ data, shareContent, pageSeo }: IProps) {
  const {
    t,
    i18n: { language },
  } = useTranslation('index', { keyPrefix: 'meta' });
  return (
    <>
      <SeoEntries
        fallback={{
          title: t('about.title'),
          description: t('about.description'),
          openGraphImage: '/images/og.png',
        }}
        seo={pageSeo}
        language={language}
        path="/about"
      />
      <main>
        <AboutPage data={data} shareContent={shareContent} h1={pageSeo?.h1} />
      </main>
    </>
  );
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  if (locale === 'default') {
    return {
      notFound: true,
    };
  }
  const [data, shareContent] = await Promise.all([
    getIndexData(locale ?? 'en'),
    getSocialData(locale ?? 'ru'),
  ]);
  if (isDevelopment) {
    await i18n?.reloadResources();
  }
  const pageSeo = await fetchPageSeo({
    path: '/about',
    language: locale ?? 'en',
  });
  return {
    props: {
      ...(await serverSideTranslations(locale ?? 'ru', ['index'])),
      data,
      shareContent,
      headerTheme: 'light',
      pageSeo,
    },
    revalidate: 360,
  };
};
